<template>
  <div class="ui-detail-box">
    <ui-row
      :gutter="20"
      :span-label="4"
      :span-value="7"
      :span-button="13"
      :row="detail.title"
      :disabled="1"
      :btn-group-style="btnGroupStyle"
    >
      <slot></slot>
    </ui-row>
    <ui-row
      :gutter="20"
      :span-label="4"
      :span-value="20"
      :row="detail.suppliername"
      :cus-style="contentBoxStyle"
      :disabled="1"
    ></ui-row>
    <ui-row
      :gutter="20"
      :span-label="4"
      :span-value="20"
      :row="detail.content"
      :cus-style="contentBoxStyle"
      :disabled="1"
    ></ui-row>
    <ui-row
      :gutter="20"
      :span-label="4"
      :span-value="20"
      :row="detail.tendercollectvias"
      :cus-style="contentBoxStyle"
      :disabled="1"
    ></ui-row>
    <ui-row
      :gutter="20"
      :span-label="4"
      :span-value="20"
      :row="detail.closingdate"
      :cus-style="contentBoxStyle"
      :disabled="1"
    ></ui-row>
    <ui-row
      :gutter="20"
      :span-label="4"
      :span-value="20"
      :row="detail.contact1"
      :cus-style="contentBoxStyle"
      :disabled="1"
    ></ui-row>
    <ui-row
      :gutter="20"
      :span-label="4"
      :span-value="20"
      :row="detail.contact2"
      :cus-style="contentBoxStyle"
      :disabled="1"
    ></ui-row>
     <ui-row
      :gutter="20"
      :span-label="4"
      :span-value="20"
      :row="detail.remark"
      :cus-style="contentBoxStyle"
      :disabled="1"
    ></ui-row> 
    <ui-row
      :gutter="20"
      :span-label="4"
      :span-value="20"
      :row="detail.supplier"
      :cus-style="contentBoxStyle"
      :disabled="0"
    ></ui-row>
  </div>
</template>

<script>
import row from "../layout/Row";
export default {
  components: {
    "ui-row": row
  },
  props: {
    detail: {
      type: Object,
      required: true
    },
    contentBoxStyle: {
      type: String,
      default: ""
    },
    btnGroupStyle: {
      type: String,
      default: ""
    },
  }
};
</script>
<style >
.tender-detail-box {
  padding: 20px;
}
.ui-detail-value {
  border: 1px solid #d5d5d5;
  border-radius: 3px;
}
</style>